import React, { useState } from 'react';

import PromptTextDialog from '@dashboard/components/destructive-action-triggers/PromptTextDialog';
import { alertSuccess } from '@dashboard/contexts/SnackbarManager/store';
import { useSendDnsInformationEmailMessageMutation } from '@dashboard/generated/wp/platform';
import { Box, Button } from '@mui/material';

type Props = {
  id: string;
};
export default function SendInstructionsDialog({ id }: Props) {
  const [open, setOpen] = useState(false);
  const [sendMessage, { loading }] = useSendDnsInformationEmailMessageMutation();

  const handleClose = () => {
    setOpen(false);
  };

  const onSubmit = async (value: string) => {
    await sendMessage({ variables: { id, toEmailAddress: value } });
    alertSuccess(`Email sent to ${value}`);
    handleClose();
  };

  let dialog = null;
  if (open) {
    dialog = (
      <PromptTextDialog
        title="Send instructions"
        description="Send an email to your teammate with instructions on how to add these DNS records."
        loading={loading}
        open={open}
        placeholder="jane@company.com"
        handleClose={handleClose}
        onSubmit={onSubmit}
        confirmButtonLabel="Send"
        textFieldProps={{ label: 'Email address', type: 'email' }}
      />
    );
  }

  return (
    <Box mt={3}>
      <Button fullWidth variant="outlined" size="large" color="primary" onClick={() => setOpen(true)}>
        Email instructions to a teammate
      </Button>
      {dialog}
    </Box>
  );
}
